import { scheduledQuotesBlotterEpics } from 'epic/blotters/scheduledQuotesBlotter';
import { combineEpics } from 'redux-observable';

import { blotterPanelItemDetailsRequestedEpic } from './commonBlotterEpics';
import { dailyBlotterEpics } from './dailyBlotter';
import { priceImprovementBlotterEpics } from './priceImprovementBlotter';
import { quotesBlotterEpics } from './quotesBlotter';
import { tradesBlotterEpics } from './tradesBlotter';

export const blotterEpics = () =>
  combineEpics(
    blotterPanelItemDetailsRequestedEpic(),
    quotesBlotterEpics(),
    tradesBlotterEpics(),
    dailyBlotterEpics(),
    priceImprovementBlotterEpics(),
    scheduledQuotesBlotterEpics(),
  );
